export const ImageFileExtensions = ['jpg', 'jpeg', 'png', 'gif'] as const;
export type ImageFileExtension = typeof ImageFileExtensions[number];

export const DocumentFileExtensions = ['pdf', 'txt', 'rtf', 'doc', 'docx', 'xls', 'xlsx'] as const;
export type DocumentFileExtension = typeof DocumentFileExtensions[number];

export const DataFileExtensions = ['csv'] as const;
export type DataFileExtension = typeof DataFileExtensions[number];

export const NonVideoFileExtensions = 
    [...ImageFileExtensions, ...DocumentFileExtensions, ...DataFileExtensions] as const;


export const VideoFileExtensions = ['mp4', 'mov'] as const;
export type VideoFileExtension = typeof VideoFileExtensions[number];

export const FileExtensions = 
    [...ImageFileExtensions, ...DocumentFileExtensions, ...DataFileExtensions, ...VideoFileExtensions] as const;

export type FileExtension = 
    ImageFileExtension
    | VideoFileExtension
    | DocumentFileExtension
    | DataFileExtension;